import type { AuthSlice } from 'app/auth/types';
import type { ProjectSlice } from 'app/project/types';
import { connect } from 'react-redux';
import { getPermission } from '../../selectors.js';
import PermissionsWrapper, {
  type PermissionsWrapperOwnProps,
  type PermissionsWrapperStateProps
} from './permissions-wrapper';

function mapStateToProps(
  state: AuthSlice & ProjectSlice,
  ownProps: PermissionsWrapperOwnProps
): PermissionsWrapperStateProps {
  return {
    permission: getPermission(state, ownProps)
  };
}

export default connect(mapStateToProps)(PermissionsWrapper);
